import React from "react";
import { Row } from "@masterteam/mt-design-react";

import SummaryCard from "./SummaryCard";

import "./style.scss";

const SummaryCharts = ({
  strategy,
  kpiStatuses,
  projectStatuses,
  chartTitle1 = "strategy-map.kpis-summary",
  chartTitle2 = "strategy-map.projects-summary"
}) => {
  return (
    <Row size="large" align="stretch">
      <SummaryCard
        data={strategy?.KPIChart?.ChartData}
        detailsData={strategy?.KPIChart?.List || []}
        title={chartTitle1}
        detailsTitle="strategy-map.kpis-list"
        statuses={kpiStatuses}
        totalCount={strategy?.KPIChart?.Count}
      />

      <SummaryCard
        data={strategy?.ProjectChart?.ChartData || []}
        detailsData={strategy?.ProjectChart?.List || []}
        title={chartTitle2}
        detailsTitle="strategy-map.projects-list"
        statuses={projectStatuses}
        totalCount={strategy?.ProjectChart?.Count}
        isProject
      />
    </Row>
  );
};

export default SummaryCharts;
